import React from 'react';
import superagent from 'superagent';
import { fromUnixTime, formatDistanceToNow } from "date-fns";
import { formatInTimeZone } from 'date-fns-tz';
import { Segment, Form, Table, Statistic, Label, Button, Icon, Pagination, Header } from 'semantic-ui-react'
import { DateInput } from 'semantic-ui-calendar-react';

import constants, { DEFAULT_TIMEZONE } from '../CloudApi/Constants.js';
import * as ApiUtils from '../CloudApi/ApiUtils.js';
import InventoryWrapper from './InventoryWrapper.jsx';
import ProductsTable from './ProductsTable.jsx';
import HandScannerInput from '../Util/HandScannerInput.jsx';

export default class ProductsHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPageIndex: 1,
            pageCount: 0,
            items: [],
            query: {
            },
            limit: 50,
            offset: 0,
            count: 0,
        };
    }

    async componentDidMount() {
        try {
            let schemas = await ApiUtils.getFabricatorSchemas();
            this.setState({ schemas });
            await this.onUpdateQuery();
        } catch (e) {
            console.log(e);
        }
    }

    onChange(e, { name, value }) {
        const query = this.state.query;

        if (_.isEmpty(value)) {
            console.log("delete", name, value);
            delete query[name];
        } else {
            if (name === "state" && value === ApiUtils.ANY_VALUE) {
                delete query["state"];
            } else if (name === "shopifyMinCreatedAt") {
                query["minCreatedAt"] = new Date(value).getTime();
            } else if (name === "shopifyMaxCreatedAt" && !_.isEmpty(value)) {
                query["maxCreatedAt"] = new Date(value).getTime();
            } else {
                query[name] = value;
            }
        }

        this.setState({ query }, async () => {
            const params = this.getUrlSearchParams();
            console.log(params.toString());
            const newPathQuery = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState(null, '', newPathQuery);
            await this.onUpdateQuery();
        });
    }

    async onUpdateQuery() {
        try {
            this.setState({ loading: true });
            const res = await superagent.get(`/api/admin/shop/products`);
            console.log(res.body);
            this.setState({ items: res.body, count: res.body.length });
        } catch (e) {
            this.setState({ error: e });
        }
        this.setState({ loading: false });
    }

    render() {
        if (!this.state.schemas) {
            return <div />;
        }

        return (
            <InventoryWrapper title="Shopify Inventory">
                {this.state.count > 0 && <ProductsTable schemas={this.state.schemas} productsList={this.state.items} count={this.state.count} loading={this.state.loading} />}
                {this.state.loading && <Segment basic loading={this.state.loading} />}
            </InventoryWrapper>
        );
    }
}
